/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StageMinusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACzElEQVR4nMVV3YuMYRTfC9ZXWCQSbijiL5AYxWaycz5m651zxi4j7Y4LCSlFG7Z8jBt/yPqIiE0prVxI1scF0i4pu66sZdW2xdJ55+zsu+adWXaVp6bmeZ5zzu/8fuc8562p+Z8LEecjayuSdgDrO2QZQJJhYH2NpFeRdX8y2bTgrwMHQVALJCeB9Suy/qz2A9JPZpvP52f+Yda6AlieeoBRJLkLrDnEYJ1la+Cpxux6omwLktwbB5JHqVSwumpwIlmFrO9DJ5JXRLJlsoSIZBuQ9jjQ23S6aWUlWeYAy2MPfp8oV2fnu4JgOZCeRdJnyPINSIeApRtI2wF0mdk0NOxehCQPQiYs3bFyIWuba/oyCIKF4VlaAiAdrFwDGQCWxgjIG79rmxDcLr2go9CY2ezUBUh+eFY3TAqrgTFDzOxA0tue0PcxELNx+8/WgREdsy1+0VmSxTsISI9X0h9ZT7vNYDIIltoZsHY5i9aSoWVYBNDm0JHkfLEWet3rU4ssF4GkH1j6kLVgZ+7b6V10xkFb3bdjPBOS3tAIgrXu9CI0wsxWdyrE1KBQZJ/Z6QGfhL6gG51VTxRg2A6TyeSs6D6VSs0NnUj6ywBIPzq7xV7wL0XAXJ0DDJUBJBKJGdF9fX3zPGfUF8PgQxTAamZ7a4QygOKcKZcoRbK9kkRAeiFOIsRgg7+l3ggDvema7/WA58J9Wg+OF1kLxqSsyKSHHLDdO/KAd+TlaBflHfWO7Zn3LAHWE/Y+KrXohDdEctKkirIFkn0lI7s0zUJZOLspGiCRy81GlsM2zIB0xMZJzVQWspxyapcmDj95/pv2R6YEEA470nYbxba3li29h8hvTApgfTjZt8IGYEVAyzTOyeoTMvbpWfVjxNpVBUBuxTqiHp2SRGUALGTzP6b/R4D02BiTaa3ieM62AMu14rySAf/w2/8rzLLmn7CZzvoF2AULQbyGUqgAAAAASUVORK5CYII=)
 */
export const StageMinusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6.33 20.03c-.25.72.12 1.5.8 1.84a10.96 10.96 0 0 0 7.97.69c.36-.1.27-.56-.1-.56a3 3 0 0 1-2.28-4.95c.3-.35.2-1-.25-1.03a6 6 0 0 0-6.14 4.01Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.9 16c.21 0 .4-.13.47-.32A11 11 0 1 0 2.9 18.2c.34.5 1.05.51 1.46.07l.02-.02c.33-.36.34-.91.07-1.33a9 9 0 1 1 15.93-1.66c-.13.35.11.74.48.74h1.04Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16.83 15.23c.43.47 1.18.42 1.45-.14a7 7 0 1 0-12.57 0c.28.56 1.03.6 1.46.14l.05-.06c.3-.33.35-.81.17-1.23A4.98 4.98 0 0 1 12 7a5 5 0 0 1 4.6 6.94c-.17.42-.13.9.18 1.23l.05.06Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM15 18a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-8Z"
        className={colorClass}
      />
    </svg>
  );
};
